type TixlyListener = (data: unknown) => void;

class Tixly {
  #iframe: HTMLIFrameElement;
  #url = '';
  #loading = false;
  #events: TixlyListener[] = [];

  constructor() {
    this.#iframe = document.createElement('iframe');
    this.#iframe.classList.add('visible-hidden');
    this.#iframe.name = 'tixly-itix-user';
    document.body.appendChild(this.#iframe);

    window.addEventListener('message', this.onMessage, false);
    this.#iframe.addEventListener('load', this.onLoad);
  }

  onLoad = () => {
    this.#iframe.contentWindow!.postMessage('GetSession', '*');
    this.#loading = false;
  };

  onMessage = (event: MessageEvent) => {
    if (!this.#url) return;
    const url = new URL(this.#url);
    if (event.origin !== url.origin) return;
    const data = event.data;
    this.#events.forEach(listener => {
      listener(data);
    });
  };

  setUrl = (url: string) => {
    this.#url = url;
    this.refresh();
  };

  refresh = () => {
    if (!this.#loading) {
      this.#loading = true;
      this.#iframe.src = this.#url;
    }
  };

  // add event to the list if it doesn't exist
  addEventListener = <T>(event: (data: T) => void) => {
    const listener = event as TixlyListener;
    if (this.#events.includes(listener)) {
      return;
    }

    this.#events.push(listener);
  };

  // remove event from the list if it exists
  removeEventListener = <T>(event: (data: T) => void) => {
    const listener = event as TixlyListener;
    if (!this.#events.includes(listener)) {
      return;
    }

    this.#events = this.#events.filter(e => e != listener);
  };
}

export const tixly = new Tixly();

export default tixly;
